import { combineReducers } from 'redux';
import milkReducer from './milkReducer';

const rootReducer = combineReducers({
  milk: milkReducer
});

export default rootReducer;
